import { Loader2 } from 'lucide-react';
import { Dialogo } from '@/components/ui/overlay';
import { diaLargo } from '@/lib/utils';
import { useAgendaDia, useConfig } from './datos';
import { useHorarioAtencion } from './horarioAtencion';
import { VistaDia } from './VistaDia';

interface Props {
  dia: string;
  barberoId: string;
  /** Cita que se está moviendo: no se dibuja, su horario cuenta como libre. */
  excluirCitaId?: string;
  /** Hora local `HH:mm` del hueco tocado. */
  onHora: (hora: string) => void;
  onCerrar: () => void;
}

/** Agenda del día de un solo barbero, solo para consultar: tocar un hueco libre elige esa hora. */
export function VerAgendaDialog({ dia, barberoId, excluirCitaId, onHora, onCerrar }: Props) {
  const agenda = useAgendaDia(dia);
  const intervalo = useConfig<number>('agenda.intervaloMinutos', 15);
  const sucursal = useHorarioAtencion(null, dia);
  const barbero = agenda.data?.barberos.find((b) => b.id === barberoId);
  const citas = (agenda.data?.citas ?? []).filter((c) => c.barberoId === barberoId && c.id !== excluirCitaId);
  const horario = sucursal && sucursal !== 'descanso' ? sucursal : null;

  return (
    <Dialogo
      abierto
      ancho="lg"
      onCambiarAbierto={(v) => !v && onCerrar()}
      titulo={`Agenda de ${barbero?.nombre ?? 'el barbero'}`}
      descripcion={`${diaLargo(dia)}. Toca un horario libre para usarlo en la cita.`}
    >
      {barbero ? (
        <VistaDia
          dia={dia}
          apertura={horario?.entrada ?? '10:00'}
          cierre={horario?.salida ?? '21:00'}
          intervaloMin={intervalo}
          barberos={[barbero]}
          citas={citas}
          mostrarSinAsignar={false}
          onCita={() => {}}
          onHueco={(_, hora) => {
            onHora(hora);
            onCerrar();
          }}
        />
      ) : agenda.isError || agenda.isSuccess ? (
        // Con solo «Ver su propia agenda» la respuesta no trae a los demás barberos.
        <p className="rounded-md bg-muted px-3 py-2 text-[13px] text-foreground-muted">
          {agenda.isError ? 'No se pudo cargar la agenda. Cierra y vuelve a intentarlo.' : 'No puedes ver la agenda de este barbero.'}
        </p>
      ) : (
        <Loader2 className="size-4 animate-spin text-accent" aria-label="Cargando agenda" />
      )}
    </Dialogo>
  );
}
